import React, { useEffect, useState } from "react";
import {
  FaChartLine,
  FaPiggyBank,
  FaLock,
  FaBalanceScale,
  FaCoins,
  FaRocket,
} from "react-icons/fa";
import { MdDelete, MdEditDocument } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "../store/store";

const iconMap = {
  "Gold Plan": <FaCoins className="text-yellow-500 text-3xl" />,
  "Silver Plan": <FaBalanceScale className="text-gray-500 text-3xl" />,
  "Starter Plan": <FaRocket className="text-blue-500 text-3xl" />,
  "Platinum Plan": <FaPiggyBank className="text-purple-500 text-3xl" />,
  "Safe Growth Plan": <FaLock className="text-green-500 text-3xl" />,
  "Balanced Fund": <FaChartLine className="text-indigo-500 text-3xl" />,
};

const borderColorMap = {
  "Gold Plan": "border-yellow-500",
  "Silver Plan": "border-gray-500",
  "Starter Plan": "border-blue-500",
  "Platinum Plan": "border-purple-500",
  "Safe Growth Plan": "border-green-500",
  "Balanced Fund": "border-indigo-500",
};

function InvestmentsTab() {
  const { getAllInvestmentPlans, user } = useAuthStore();
  const [investmentPlans, setInvestmentPlans] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchInvestmentPlans = async () => {
      try {
        const response = await getAllInvestmentPlans();
        if (response?.data) {
          setInvestmentPlans(response.data);
        }
      } catch (error) {
        console.error("Error fetching investment plans:", error);
      }
    };
    fetchInvestmentPlans();
  }, []);

  return (
    <div className="bg-gray-800 min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-white mb-8 text-center">
          Investment Plans
        </h2>
        {location.pathname !== "/" && user?.accountType === "admin" && (
          <button
            type="button"
            onClick={() =>
              (window.location.href = "/dashboard/CreateInvestmentPlan")
            }
            className="mt-6 w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-lg font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Create Plan
          </button>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-6">
          {investmentPlans.map((plan) => (
            <div
              key={plan._id}
              className={`bg-gray-800 border-l-4 ${
                borderColorMap[plan.investmentPlanName] || "border-gray-300"
              } rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300`}
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  {iconMap[plan.investmentPlanName] || (
                    <FaCoins className="text-gray-500 text-3xl" />
                  )}
                  <h3 className="text-2xl font-semibold text-white ml-3">
                    {plan.investmentPlanName}
                  </h3>
                  {location.pathname !== "/" &&
                    user?.accountType === "admin" && (
                      <div style={{ display: "flex" }}>
                        <MdDelete className="text-red-600 text-3xl cursor-pointer" />
                        <MdEditDocument
                          onClick={() =>
                            (window.location.href = `/dashboard/createInvestmentEdit/${plan._id}`)
                          }
                          className="text-gray-500 text-3xl cursor-pointer"
                        />
                      </div>
                    )}
                </div>
                <ul className="text-white space-y-2">
                  <li>
                    <strong>Interest Rate:</strong> {plan.interestRate}
                  </li>
                  <li>
                    <strong>Investment Limit:</strong> {plan.investmentLimit}
                  </li>
                  <li>
                    <strong>Returns:</strong> {plan.returns}
                  </li>
                  <li>
                    <strong>Investment Duration:</strong>{" "}
                    {plan.investmentDuration}
                  </li>
                  <li>
                    <strong>Capital Growth:</strong> {plan.capitalGrowth}
                  </li>
                  <li>
                    <strong>Risk Level:</strong> {plan.riskLevel}
                  </li>
                  <li>
                    <strong>Total Return:</strong> {plan.totalReturn}
                  </li>
                </ul>
                <button
                  type="button"
                  onClick={() => (window.location.href = `/dashboard/deposit`)}
                  className="mt-6 w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-lg font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
                >
                  Invest Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default InvestmentsTab;